import { useEffect, useState } from "react";
import { Chip, colors, FormControl, IconButton, Button, OutlinedInput, InputAdornment } from "@mui/material";
import { Box } from "@mui/material/node_modules/@mui/system";
import { Search } from "@mui/icons-material";

const boxOffsetTop = 55;

interface NavBarProps {
  onSearch: (value?: string) => void;
  links: { id: string, value: string, href: string }[];
}

export function NavBar({ links, onSearch }: NavBarProps) {
  const [currentScrollTop, setCurrentScrollTop] = useState(0);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isMobileApp] = useState(!!(window as any)?.mapp);

  useEffect(() => {
    const onScroll = () => {
      let currentPosition = window.pageYOffset;
      setCurrentScrollTop(currentPosition <= 0 ? 0 : currentPosition);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [currentScrollTop]);

  return (
    <Box
      boxShadow={4}
      sx={{
        position: isMobileApp || currentScrollTop > boxOffsetTop ? 'fixed' : 'absolute',
        overflowX: 'scroll',
        whiteSpace: 'nowrap',
        padding: '14px',
        zIndex: 99,
        background: 'white',
        top: isMobileApp || currentScrollTop > boxOffsetTop ? '0' : `${boxOffsetTop}px`,
        left: 0,
        right: 0,
        borderBottom: `1px solid ${colors.grey[200]}`,
        display: 'flex'
      }}>
      {isSearchOpen ? (
        <form onSubmit={(e) => {
          e.preventDefault();
          onSearch(searchValue);
        }}>
          <FormControl>
            <OutlinedInput
              size="small"
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton onClick={() => onSearch(searchValue)}>
                    <Search />
                  </IconButton>
                </InputAdornment>
              )}
            />
          </FormControl>
          <Button onClick={() => {
            setIsSearchOpen(false);
            onSearch('');
          }}>
            Cancel
          </Button>
        </form>
      ) : (
        <>
          <IconButton onClick={() => setIsSearchOpen(true)}><Search /></IconButton>
          <Box sx={{ borderRight: `1px solid ${colors.grey[200]}`, display: 'inline', marginRight: '16px' }} />
          {links.map(({ id, value }) => (
            <Chip
              key={id}
              label={value}
              component="button"
              onClick={() => document.getElementById(id)?.scrollIntoView({ inline: 'start' })}
            />
          ))}
        </>
      )
      }
    </Box >
  );
}
